// src/theme/theme.ts
import { createTheme } from '@mui/material/styles';

// Custom theme for the Beekeeping App
const theme = createTheme({
  palette: {
    primary: {
      main: '#FFC107', // Amber - resembles honey
      light: '#FFD54F',
      dark: '#fa8504',
    },
    secondary: {
      main: '#8D6E63', // Brown - earthy tone
      light: '#A1887F',
      dark: '#5D4037',
    },
    background: {
      default: '#FFF8E1', // Light honey color
      paper: '#FFF3E0',
    },
    text: {
      primary: '#3E2723', 
      secondary: '#030303FF',
      
    },
  },
  typography: {
    fontFamily: 'sans-serif-etna, Arial, sans-serif',
    h1: {
      fontFamily: 'sans-serif-etna, serif',
      fontWeight: 700,
    },
    h2: {
      fontFamily: 'sans-serif-etna, serif',
      fontWeight: 600,
    },
    h3: {
      fontFamily: 'sans-serif-etna, serif',
      fontWeight: 600,
    },
    button: {
      textTransform: 'none',
      fontWeight: 600,
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: '#FFC107', // Darker amber for AppBar
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '20px',
        },
      },
    },
  },
});

export default theme;